import React from "react";
import styles from "./filterSelect.module.css";

const FilterSelect = ({
  icon,
  label,
  value,
  loading,
  options,
  onChange,
  onFocus,
  hasFetched,
  disabled = false,
}) => {
  // Protege contra options nulo/undefined ou com elementos nulos vindos da API
  const safeOptions = Array.isArray(options)
    ? options.filter((opt) => opt !== null && opt !== undefined)
    : [];

  const valueInOptions = value && safeOptions.some(
    (opt) => String(opt?.id ?? opt) === String(value)
  );

  return (
    <div className={styles.filterSelect}>
      {icon && <img src={icon} alt="" className={styles.icon} />}

      <select
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        className={styles.selectElement}
        disabled={disabled}
      >
        {loading ? (
          <option value="">{`Carregando ${label}...`}</option>
        ) : hasFetched && safeOptions.length === 0 ? (
          <option value="" disabled>{`Nenhum dado de ${label} encontrado`}</option>
        ) : (
          <>
            <option value="">{label}</option>
            {value && !valueInOptions && (
              <option value={value}>{value}</option>
            )}
            {safeOptions.map((opt) => (
              <option key={opt?.id ?? opt} value={opt?.id ?? opt}>
                {opt?.name ?? opt}
              </option>
            ))}
          </>
        )}
      </select>
    </div>
  );
};

export default FilterSelect;
